export default function getOrganizationsReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_ORGANIZATIONS_BLOCK_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_ORGANIZATIONS_BLOCK_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_ORGANIZATIONS_BLOCK_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}